import SectionHeader from '../components/SectionHeader';
import AdvisorCard from '../components/AdvisorCard';
import { teamMembers } from '../data/content';

function Advisor() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="Meet Our Advisors" title="Our professional consulting team" />
      <div className="team-grid">
        {teamMembers.map((member) => (
          <AdvisorCard
            id={member.id}
            key={member.id}
            name={member.name}
            title={member.role}
            onKnowMoreClick={() => console.log(`Know more clicked for ${member.name}`)}
            onContactClick={() => console.log(`Contact clicked for ${member.name}`)}
          />
        ))}
      </div>
    </section>
  );
}

export default Advisor;